import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {  useParams,useNavigate  } from "react-router-dom";
// import { IconFileText, IconVideo, IconLink, IconBook } from "@tabler/icons-react";
import { setCurrentPage, setSidebarRouteData } from "../../../store/actions/mainActions";
import eventsService from "../../../Axios/services/events.service";
import CurriculumFolder from "../../content/Curricula/CurriculumFolder/CurriculumFolder";
import CurriculumCI from "../../content/Curricula/CurriculumCI/CurriculumCI";
import "./EventPageLibrary.scss";

export const EventPageLibrary = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const { me } = useSelector((state: any) => state.auth);
  const { currentEvent } = useSelector((state: any) => state.main);
  const [related, setRelated] = useState<any>(undefined);
  const [filteredRelated, setFilteredRelated] = useState<any>(undefined);
  const [entityLanguage, setEntityLanguage] = useState("common");
  const [event, setEvent] = useState<any>(undefined);
  const [t] = useTranslation(entityLanguage);

  useEffect(() => {
    if (me) {
      getCourse();
    }
    return () => {
      dispatch(setSidebarRouteData({}));
      dispatch(setCurrentPage(""));
    };
  }, [me]);

  useEffect(() => {
    setFilteredRelated(related);
  }, [related]);

  const isBelongToUser = (e: any) => {
    return me?.events?.includes(e?._id);
  };

  const renderFileIcon = (type: any) => {
    switch (type) {
      case "hartman_link":
      case "external_link":
        return; //<IconLink strokeWidth={"1"} width="35px" height="35px" />;
      case "file":
        return; //<IconFileText strokeWidth={"1"} width="35px" height="35px" />;
      case "recording_session":
        return; // <IconVideo strokeWidth={"1"} width="35px" height="35px" />;
      case "sefaria_link":
        return; //<IconBook strokeWidth={"1"} width="35px" height="35px" />;
    }
  };

  const getCourse = async () => {
    const e = currentEvent?._id ? currentEvent : await eventsService.getEvent(id);
    if (e) {
      setEvent(e);
      setEntityLanguage(e.language);
      if (isBelongToUser(e)) {
        if (e.related) {
          let _related = e.related.map((r: any) => {
            return {
              created: new Date(r.created),
              title: r.title,
              type: "",
              content: r,
              typeName: "",
              icon: renderFileIcon(r.type),
              _id: r._id,
            };
          });
          setRelated(_related);
        }
        dispatch(setCurrentPage("EventPageLibrary"));
        dispatch(setSidebarRouteData({ id }));
      }
    }
  };

  return filteredRelated ? (
    <div className={`container-fluid course-page-library ${entityLanguage === "English" ? null : "alignRight"}`}>
      <div className="goBack" onClick={() => navigate("/my-campus/event/timeline/" + id)}>
        {t("Back to seminar")}
      </div>
      <div className="x-md-0">
        <h2 className="mb-3">{t("Seminar Library")}</h2>
      </div>

      <div className="mx-mx-0">
        <div className="list-group">
          {filteredRelated
            .sort((a: any, b: any) => b.content.created - a.content.created)
            .map((r: any, index: number) => (
              <div className="mb-4 mr-3" key={index}>
                <CurriculumCI key={index} item={r} mode={"insideFolder"} />
              </div>
            ))}
        </div>
      </div>
      {event && event.folderList && event.folderList.length > 0
        ? event.folderList.map((folder: any, index: number) => <CurriculumFolder key={index} item={folder} language={event.language} />)
        : null}
    </div>
  ) : (
    <div className="loaderContainer d-flex flex-column">
      <div className="loader"></div>
      <div className="loaderText">Loading Library</div>
    </div>
  );
};
